<template>
    <div class="operator-wrap">
        <component
            :is="btn.type || 'Button'"
            class="operator-button"
            v-for="btn in options"
            :key="btn.id"
            @btnClick="btnClick(btn.id)"
            :text="btn.text"
        />
    </div>
</template>

<script>
import Button from "@/views/zhiji/bComponents/buttons/Button";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";
import { conventionalOperate } from "../../clusterPageConfig.js";

import i18n from "@/i18n";

export default {
    name: "ConventionalColumn",
    props: ["row"],
    components: {
        Button,
        QuestionEditModal
    },
    computed: {
        options() {
            return conventionalOperate();
        }
    },
    methods: {
        btnClick(itemId) {
            const handler = {
                add: this.addQuestionClick,
                linked: this.linkedSimilarClick,
                delete: this.deleteClick
            };
            handler[itemId].call(null);
        },
        addQuestionClick() {
            let addData = this.row.addData;
            this.$store.dispatch("zhiji/showModal", {
                type: QuestionEditModal,
                data: {
                    conventionQuestionId: addData.rowId,
                    standQuestion: addData.question,
                    closeHandler: () => {
                        this.$store.dispatch("zhiji/queryConventionalList", {});
                    }
                }
            });
        },
        linkedSimilarClick() {
            let addData = this.row.addData;
            let questionArr = [
                {
                    questionId: addData.rowId,
                    questionText: addData.question
                }
            ];
            this.$store.dispatch("zhiji/showModal", {
                type: "LinkedQuestionModal",
                data: {
                    question: questionArr,
                    title: i18n.t("zhiji.cluster.closeLoop.linkSimilar"),
                    confirm: data => {
                        this.saveLinkedQuestion(data);
                    }
                }
            });
        },
        saveLinkedQuestion(data) {
            this.zhiji
                .requestByServiceName("linkedConventional", {
                    questions: data.questionArray,
                    questionIds: data.questionIdArray,
                    linkQuestionId: data.linkQuestionId
                })
                .then(resp => {
                    if (resp.errCode) {
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "error",
                                message: resp.errMessage
                            }
                        });
                    }
                    this.$store.dispatch("zhiji/queryConventionalList", {});
                });
        },
        deleteClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.cluster.deleteConfim") + " " + this.row.addData.question + " " + i18n.t("zhiji.cluster.deleteQues"),
                    cancel: () => {},
                    confirm: () => {
                        this.zhiji
                            .requestByServiceName("deleteConventional", {
                                questionIds: JSON.stringify([this.row.addData.rowId])
                            })
                            .then(() => {
                                this.$store.dispatch("zhiji/queryConventionalList", {});
                            });
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.operator-wrap {
    white-space: nowrap;

    .operator-button {
        font-size: 12px;
        margin-right: 8px;
        border: 1px solid #d8e4f0;
        padding: 3px 8px;
        background: #fff;
        border-radius: 4px;
        height: 24px;
        line-height: 24px;

        &:hover {
            color: #2ec2ff;
            cursor: pointer;
        }
    }
}
</style>
